export const SHORTCUT_ACTION = 'SHORTCUT_ACTION';
